function toggleTabAccount() {
	$(".tabTitleAccount").show();
	$(".tabContentAccount").hide();
	$(".tabContentAccount:first").show();

	$(".tabTitleAccount li").click(function() {
		$(".tabContentAccount").hide();
		var activeTab = $(this).attr("rel");
		$("#" + activeTab).fadeIn();
		$(".tabTitleAccount li").removeClass("active");
		$(this).addClass("active");
	});
	$(".tabContentClose").click(function() {
		$(".tabContentAccount").hide();
		$(".tabTitleAccount li").removeClass("active");
	});
	
}